"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _jsonStableStringify = _interopRequireDefault(require("json-stable-stringify"));

var _semanticUiReact = require("semantic-ui-react");

var _Fonts = require("../00_environment/Fonts");

var _FormElement = _interopRequireDefault(require("../01_atoms/FormElement"));

var _FormElementGroup = _interopRequireDefault(require("../01_atoms/FormElementGroup"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _EditPassengerForm = _interopRequireDefault(require("./EditPassengerForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BillingDetailsWidget = /*#__PURE__*/function (_Component) {
  _inherits(BillingDetailsWidget, _Component);

  var _super = _createSuper(BillingDetailsWidget);

  function BillingDetailsWidget(props) {
    var _this;

    _classCallCheck(this, BillingDetailsWidget);

    _this = _super.call(this, props);
    _this.state = {
      selectedPassenger: null
    };
    return _this;
  }

  _createClass(BillingDetailsWidget, [{
    key: "onSelectedPassengerChange",
    value: function onSelectedPassengerChange(selectedPassenger) {
      console.log("onSelectedPassengerChange(".concat(selectedPassenger, ")"));
      this.setState({
        selectedPassenger: selectedPassenger
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps, prevState) {
      if (prevState.selectedPassenger !== this.state.selectedPassenger) {
        return true;
      }

      if (prevProps.setBillingInfo !== this.props.setBillingInfo) {
        console.log('Rendering BillingDetailsWidget -- setBilingInfo changed');
        return true;
      }

      if (prevProps.onBack !== this.props.onBack) {
        console.log('Rendering BillingDetailsWidget -- onBack changed');
        return true;
      }

      if ((0, _jsonStableStringify["default"])(prevProps.savedPassengers) !== (0, _jsonStableStringify["default"])(this.props.savedPassengers)) {
        console.log('Rendering BillingDetailsWidget -- savedPassengers changed');
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      console.log('Rendering BillingDetailsWidget / IN RENDER');
      var _this$props = this.props,
          sdk = _this$props.sdk,
          userPassengerId = _this$props.userPassengerId,
          billingPassengerId = _this$props.billingPassengerId,
          savedPassengers = _this$props.savedPassengers,
          onBack = _this$props.onBack,
          _this$props$setBillin = _this$props.setBillingInfo,
          setBillingInfo = _this$props$setBillin === void 0 ? function () {} : _this$props$setBillin,
          translatorForNamespace = _this$props.translatorForNamespace;
      var sPgr = this.state.selectedPassenger;
      var t = translatorForNamespace('CreditCardPaymentPageUI');
      var selectedPassenger = sPgr || billingPassengerId || userPassengerId;
      console.log("Rendering with selectedPassenger = ".concat(selectedPassenger));
      return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
        title: t('Billing details')
      }, /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
        title: t('Which person should we bill this trip to?')
      }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
        placeholder: t('Select Passenger'),
        fluid: true,
        search: true,
        selection: true,
        options: [].concat(_toConsumableArray(savedPassengers.map(function (p) {
          return {
            key: p.id,
            value: p.id,
            icon: 'user',
            text: "".concat(p.firstName, " ").concat(p.lastName)
          };
        })), [{
          key: 'other',
          value: 'other',
          icon: 'question',
          text: t('Bill this trip to someone else')
        }]),
        onChange: function onChange(e, o) {
          _this2.onSelectedPassengerChange(o.value);
        },
        value: selectedPassenger
      }))))), /*#__PURE__*/_react["default"].createElement(_EditPassengerForm["default"], _extends({
        noWrap: true
      }, {
        sdk: sdk,
        translatorForNamespace: translatorForNamespace,
        defaultValue: !selectedPassenger || selectedPassenger === 'other' ? null : savedPassengers.find(function (p) {
          return p.id === selectedPassenger;
        }),
        submitButtonLabel: t('Validate billing info'),
        onSubmit: function onSubmit() {
          var _console;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          (_console = console).log.apply(_console, ['Calling setBillingInfo with args: '].concat(args));

          setBillingInfo.apply(void 0, args);
        },
        leftButtonLabel: t('Back'),
        onLeftButtonClick: onBack,
        leftButtonColor: null,
        validationRequirement: 'extended',
        config: {
          name: {
            title: t('Name'),
            subtitle: '',
            show: !selectedPassenger || selectedPassenger === 'other'
          },
          phone: {
            title: t('Phone number'),
            subtitle: '',
            show: !selectedPassenger || selectedPassenger === 'other'
          },
          ssn: {
            title: t('Identification document'),
            subtitle: '',
            show: !selectedPassenger || selectedPassenger === 'other'
          },
          email: {
            show: true
          },
          address: {
            show: true
          }
        }
      })));
    }
  }]);

  return BillingDetailsWidget;
}(_react.Component);

var _default = BillingDetailsWidget;
exports["default"] = _default;